import React from 'react';
import Material from './Material';

/**
 * 自定义视频组件
 * 
 * 加载本地文件路径  let src = 'assets/images/xxx/xxx.png';  以'assets/'开始
 * 加载服务器文件路径  let src = `${ele.preview}`; 不以'assets/'开始
 *
 */
export default class Video extends Material {
  
  render() {
    return (
      <video width="400" height="auto" {...this.props} poster={this.state.poster} src={this.state.src} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Material/Video.js